import { useQuery } from "@tanstack/react-query"

import { client } from "@/api"
import queryKeys from "@/api/queryKeys"

function useListAdvertisementSlots() {
  return useQuery({
    queryKey: queryKeys.advertisements.slots().queryKey,
    queryFn: () =>
      client.get(`/advertisements/slots`).then((response) => response.data),
  })
}
export default useListAdvertisementSlots
